import useSWR from "swr";
import { useDateFilters } from "../../../hooks/useDateFilters";
import { formatDateRange } from "../../../../../utils/helpers/api";
import { useUser } from "../../../../../utils/hooks/user";

export const useRetroAdjustments = (user) => {
    const loggedUser = useUser();
    const { from, to } = useDateFilters();
    const { data, mutate } = useSWR(() => {
        if (!user?.id || !loggedUser?.permissions?.timeSheet?.canViewRetro) {
            return null;
        }
        return {
            url: `/retro-adjustment/user/${user.id}`,
            params: {
                ...formatDateRange(from, to),
                pagination: "false",
                status: ["pending", "approved"]
            },
        };
    });
    return { data, mutate };
}
